import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Option from './pricingoptions/Option';
import { optionsData } from '../data';
import Slider from 'react-slick';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { enProduccionConMemForegroundOnPage } from '../enProduccionConMemReadableText';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';

const Pricing = () => {
  const theme = useTheme();
  const headingColor = enProduccionConMemForegroundOnPage(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    defaultMatches: true,
  });

  const sliderOpts = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !isMobile,
    prevArrow: !isMobile && (
      <ArrowCircleLeftIcon
        sx={{
          fontSize: 40,
          color: headingColor,
          '&:hover': { color: theme.palette.secondary.main },
        }}
      />
    ),
    nextArrow: !isMobile && (
      <ArrowCircleRightIcon
        sx={{
          fontSize: 40,
          color: headingColor,
          '&:hover': { color: theme.palette.secondary.main },
        }}
      />
    ),
  };

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Modelos de asociación
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h2"
          align="center"
          sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
        >
          En Producción con MEM
        </Box>
        {optionsData.length > 1 && (
          <Box display="flex" justifyContent="center" alignItems="center" marginTop={2} gap={1}>
            <ArrowForwardIcon
              sx={{
                color: headingColor,
                fontSize: 20,
                animation: 'swipe 2s ease-in-out infinite',
                '@keyframes swipe': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '50%': { transform: 'translateX(10px)' },
                },
              }}
            />
            <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
              Desliza para ver más opciones
            </Typography>
            <ArrowForwardIcon
              sx={{
                color: headingColor,
                fontSize: 20,
                animation: 'swipe 2s ease-in-out infinite',
                '@keyframes swipe': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '50%': { transform: 'translateX(10px)' },
                },
              }}
            />
          </Box>
        )}
      </Box>
      <Slider {...sliderOpts}>
        {optionsData.map((option, index) => (
          <Box key={index} padding={{ xs: 2, sm: 4 }}>
            <Option {...option} />
          </Box>
        ))}
      </Slider>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default Pricing;
